import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/styles';
import Box from '@mui/material/Box';
import LocationCardFulfillmentMethod from 'components/Location/LocationCardFulfillmentMethod';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import LocationCardFulfillmentTypeGridItem from 'components/Location/LocationCardFulfillmentTypeGridItem';
import Typography from '@mui/material/Typography';

export const NOT_ACCEPTING_ORDERS_INFORMATION_TEXT =
  'No pickup or delivery is offered for this location';

const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    minHeight: '89px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& > :nth-child(2)': {
      marginTop: theme.spacing(2)
    }
  }
}));

/**
 * Renders available fulfillment options(CTA) and availability for catering.
 *
 * @param isClosed
 * @param isAcceptingDeliveryOrders
 * @param isAcceptingPickupOrders
 * @param beginOrder
 * @param id
 * @param doesDeliverToAddress
 * @returns {*}
 */
const CateringLocationCardFulfillmentMethods = ({
  isClosed,
  isAcceptingDeliveryOrders,
  isAcceptingPickupOrders,
  beginOrder,
  id,
  doesDeliverToAddress,
  slug
}) => {
  return (
    <React.Fragment>
      <StyledBox>
        {!isClosed && isAcceptingDeliveryOrders && (
          <LocationCardFulfillmentMethod
            isCatering
            isFullWidth
            buttonLabel={'Delivery'}
            handleButtonClick={() =>
              beginOrder(slug, fulfillmentOptions.DELIVERY)
            }
            disableButton={!doesDeliverToAddress}
            hoursType={fulfillmentOptions.DELIVERY}
            buttonDataTestId={`location-${id}-delivery-button`}
          />
        )}

        {!isClosed && isAcceptingPickupOrders && (
          <LocationCardFulfillmentMethod
            isCatering
            isFullWidth
            buttonLabel={'Pickup'}
            handleButtonClick={() =>
              beginOrder(slug, fulfillmentOptions.PICKUP)
            }
            hoursType={fulfillmentOptions.PICKUP}
            buttonDataTestId={`location-${id}-pickup-button`}
          />
        )}
      </StyledBox>

      {isClosed && (
        <LocationCardFulfillmentTypeGridItem>
          <Typography>{NOT_ACCEPTING_ORDERS_INFORMATION_TEXT}</Typography>
        </LocationCardFulfillmentTypeGridItem>
      )}
    </React.Fragment>
  );
};

CateringLocationCardFulfillmentMethods.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  doesDeliverToAddress: PropTypes.bool,
  id: PropTypes.number.isRequired,
  isAcceptingDeliveryOrders: PropTypes.bool,
  isAcceptingPickupOrders: PropTypes.bool,
  isClosed: PropTypes.bool,
  slug: PropTypes.string.isRequired
};

CateringLocationCardFulfillmentMethods.defaultProps = {
  doesDeliverToAddress: true,
  firstAvailablePickupDateOption: '',
  firstAvailableDeliveryDateOption: '',
  isAcceptingPickupOrders: true,
  isAcceptingDeliveryOrders: true,
  isClosed: false
};

export default CateringLocationCardFulfillmentMethods;
